'use strict';
const models={
 B3:{keys:3,text:30,label:'3 键'},
 B4:{keys:4,text:10,label:'长条 4 键'},
 C4:{keys:4,text:10,label:'4 键旋钮',knob:true},
 B6:{keys:6,text:10,label:'6 键'}
};
Object.keys(models).forEach(type=>{const m=models[type];m.type=type;m.baseLength=m.keys*(m.text+9)+2;m.length=m.baseLength+(m.knob?24:0);m.textOff=m.keys*3;m.mixOff=m.textOff+m.keys*m.text;m.lightOff=m.mixOff+m.keys*5;m.brightnessOff=m.lightOff+m.keys+1;if(m.knob){m.knobOff=m.baseLength;m.knobMixOff=m.knobOff+9;}});
function crc16(bytes){let crc=65535;for(const v of bytes){crc^=v<<8;for(let j=0;j<8;j++)crc=(crc&32768?crc<<1^0x1021:crc<<1)&65535;}return crc;}
function hex(bytes){return Array.from(bytes,v=>v.toString(16).padStart(2,'0').toUpperCase()).join('');}
function unhex(s){if(!/^(?:[0-9A-F]{2})+$/i.test(s))throw Error('配置数据不是有效十六进制');return Uint8Array.from(s.match(/../g),v=>parseInt(v,16));}
function keyValid(v){return v===255||(v>=32&&v<=126)||(v>=128&&v<=135)||(v>=176&&v<=179)||(v>=193&&v<=235)||v===237||(v>=240&&v<=251);}
function validate(type,p){
 const m=models[type];if(!m||!p||p.length!==m.length)throw Error('配置型号或长度不匹配');
 for(const v of p)if(!Number.isInteger(v)||v<0||v>255)throw Error('配置包含无效字节');
 for(let i=0;i<m.keys;i++){const f=p[m.keys+i],v=p[2*m.keys+i];
  if(f>4||(v!==255&&v>3))throw Error('按键 '+(i+1)+' 的功能参数无效');
  if(f===0&&!keyValid(p[i]))throw Error('按键 '+(i+1)+' 的键码不受支持');
  if((f===2||f===3)&&p[i]!==255)throw Error('按键 '+(i+1)+' 的配置格式错误');
  if(f===4&&![1,2,4].includes(p[i]))throw Error('鼠标键码错误');
 }
 for(let i=m.textOff;i<m.mixOff;i++){const v=p[i];if(v!==255&&(v<32||v>126)&&![9,10,13].includes(v))throw Error('字符串包含不受支持字符，字节偏移 '+i);}
 for(let i=m.mixOff;i<m.lightOff;i++)if(!keyValid(p[i]))throw Error('组合键包含未知或不可打印键码，字节偏移 '+i);
 if(p[m.lightOff]>4)throw Error('灯效模式错误');
 for(let i=1;i<=m.keys;i++)if(p[m.lightOff+i]>7)throw Error('灯光颜色错误');
 if(m.knob){
  for(let i=0;i<3;i++){const off=m.knobOff+i*3,v=p[off],f=p[off+1],x=p[off+2];
   if(f>5)throw Error('旋钮动作 '+(i+1)+' 的功能类型错误');
   if((f===0||f===2)&&(!keyValid(v)||x!==255))throw Error('旋钮键盘动作格式错误');
   if(f===1&&(v===255||(x!==255&&x>3)))throw Error('旋钮多媒体动作格式错误');
   if(f===3&&(v>1||x!==255))throw Error('旋钮滚轮动作格式错误');
   if(f===4&&(![1,2,4].includes(v)||(x!==255&&x>3)))throw Error('旋钮鼠标动作格式错误');
   if(f===5&&(v!==255||x!==255))throw Error('旋钮组合键格式错误');
  }
  for(let i=m.knobMixOff;i<m.length;i++)if(!keyValid(p[i]))throw Error('旋钮组合键包含无效键码');
 }
 return p;
}
function frame(type,p){validate(type,p);const body=Uint8Array.from([7,parseInt(type,16),p.length,...p]),crc=crc16(body);return Uint8Array.from([2,...body,crc&255,crc>>8,3]);}
function parseQuery(line){
 const x=/^Q62:(B3|B4|C4|B6):([0-9A-F]{2}):([0-9A-F]+):([0-9A-F]{4})$/i.exec(line);
 if(!x)throw Error('回复格式不匹配。此网页仅支持三键、长条四键、四键旋钮和六键 V6.2 配套测试固件');
 const type=x[1].toUpperCase(),status=parseInt(x[2],16),payload=unhex(x[3]);
 if(status>3)throw Error('未知存储状态');
 if(crc16([parseInt(type,16),7,status,...payload])!==parseInt(x[4],16))throw Error('设备回读 CRC 校验失败');
 validate(type,payload);return {type,status,payload};
}
function parseAck(line){
 const messages={C:'配置传输校验失败',V:'设备拒绝了无效配置',W:'写入或回读验证失败；原运行设置未切换，但 Flash 可能已进入恢复状态',B:'请松开所有按键并等待鼠标连点结束后重试',F:'配置帧不完整'};
 if(line==='S62:1')return true;
 const x=/^S62:([CVWBF])$/.exec(line);if(x)throw Error(messages[x[1]]);
 throw Error('保存回复格式错误');
}
function backup(type,payload,status){validate(type,payload);return {format:'keypad-config',version:1,deviceType:type,firmwareProtocol:7,storageStatus:status,createdAt:new Date().toISOString(),payload:Array.from(payload),crc16:hex([crc16(payload)>>8,crc16(payload)&255])};}
function restore(value,type){
 if(!value||value.format!=='keypad-config'||value.version!==1||value.deviceType!==type)throw Error('备份格式或设备型号不匹配');
 if(!Array.isArray(value.payload))throw Error('备份缺少配置');
 validate(type,value.payload);
 const expected=hex([crc16(value.payload)>>8,crc16(value.payload)&255]);
 if(value.crc16!==expected)throw Error('备份校验失败');
 return Uint8Array.from(value.payload);
}
export {models,crc16,hex,unhex,keyValid,validate,frame,parseQuery,parseAck,backup,restore};



// WEBPACK FOOTER //
// ./src/stability/codec.js